import { ENDPOINTS } from "Config/endpoints";
import protectedApi from "Config/protectedApi";

export const getCustomerNeedFn = (req) => {
    const response = protectedApi.get(`${ENDPOINTS.customer_need}`, { params: req });
    return response;
}